import { render, staticRenderFns } from "./datatable-detail.vue?vue&type=template&id=057558af&scoped=true&"
import script from "./datatable-detail.vue?vue&type=script&lang=js&"
export * from "./datatable-detail.vue?vue&type=script&lang=js&"
import style0 from "./datatable-detail.vue?vue&type=style&index=0&id=057558af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057558af",
  null
  
)

export default component.exports